module.exports = __webpack_public_path__ + "img/1.2f4fb331.jpg";